// exports MedicalRecordReviewCoderQAStatus - an immutable object 'enum'
// usage: import { MedicalRecordReviewCoderQAStatus } from '../../enums/MedicalRecordReviewCoderQAStatus';
const medicalRecordReviewCoderQAStatuses = {
    Ready: 1,
    Abandoned: 13,
    InProgress: 25,
    Complete: 50
};
Object.freeze(medicalRecordReviewCoderQAStatuses);
export const MedicalRecordReviewCoderQAStatus = medicalRecordReviewCoderQAStatuses;